import React from "react";
import plus from "../imgs/plus.png";

export default function ButtonPlus({ onClick, size = 16, style = {}, children, ...props }) {
  return (
    <div
      style={{
        background: "#ffffff44",
        borderRadius: "50%",
        height: size,
        width: size,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...style,
      }}
      onClick={onClick}
      {...props}
    >
      <img alt="plus" src={plus} style={{ filter: "brightness(1)", height: "70%", width: "70%" }} />
      {children}
    </div>
  );
} 